import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Skill } from './models/skills.model';
import { SkillsUsage } from './models/skills-usage.model';

const BASE_URL = `${environment.apiConfig.url}/skills`;

@Injectable()
export class SkillService {
  constructor(private http: HttpClient) {}
  /**
   * Shows the list of skills
   */
  getSkillsList() {
    const params = new HttpParams().set('option[showAll]', 'true');
    return this.http.get<Skill[]>(BASE_URL, { params });
  }

  getSkillById(id: string) {
    return this.http.get<Skill>(`${BASE_URL}/${id}`);
  }

  createSkill(values: Record<string, unknown>) {
    return this.http.post<Skill>(BASE_URL, values);
  }

  updateSkill(values: Record<string, unknown>, skillId: string) {
    return this.http.patch<Skill>(`${BASE_URL}/${skillId}`, values);
  }

  deleteSkill(skillId: string) {
    return this.http.delete<Skill>(`${BASE_URL}/${skillId}`);
  }

  loadSkillsAsOrgUser() {
    return this.http.get<Skill[]>(`${BASE_URL}/manage`);
  }

  getSkillsUsage() {
    return this.http.get<SkillsUsage[]>(`${BASE_URL}/usage`);
  }
}
